export const BOUNDARY_SOURCE = "cv-boundaries";
export const BOUNDARY_FILL_LAYER = "cv-boundaries-fill";
export const BOUNDARY_LINE_LAYER = "cv-boundaries-line";
export const BOUNDARY_HIGHLIGHT_FILL = "cv-boundaries-highlight-fill";
export const BOUNDARY_HIGHLIGHT_HALO = "cv-boundaries-highlight-halo";
export const BOUNDARY_HIGHLIGHT_LINE = "cv-boundaries-highlight-line";
export const BOUNDARY_HIGHLIGHT_CORE = "cv-boundaries-highlight-core";

const NONE = "__none__";

export function normalizeBoundaryId(value) {
  return value == null || value === "" ? "" : String(value);
}

export function findBoundaryFeature(geojson, selected = {}) {
  const features = geojson?.features || [];
  const boundaryId = normalizeBoundaryId(selected.boundaryId);
  if (boundaryId) {
    const byId = features.find(
      (feature) =>
        normalizeBoundaryId(feature?.properties?.boundaryId) === boundaryId ||
        normalizeBoundaryId(feature?.id) === boundaryId
    );
    if (byId) return byId;
  }
  const name = String(selected.neighborhood || selected.name || "").trim().toLowerCase();
  const municipality = String(selected.municipality || "").trim().toLowerCase();
  if (!name) return null;
  return (
    features.find((feature) => {
      const props = feature?.properties || {};
      const featureName = String(props.name || props.neighborhood || "").trim().toLowerCase();
      const featureMuni = String(props.municipality || "").trim().toLowerCase();
      return featureName === name && (!municipality || featureMuni === municipality);
    }) || null
  );
}

export function buildBoundaryHighlightFilter(selectedBoundaryId) {
  const id = normalizeBoundaryId(selectedBoundaryId);
  if (!id) {
    return ["==", ["get", "boundaryId"], NONE];
  }
  return ["==", ["to-string", ["coalesce", ["get", "boundaryId"], ""]], id];
}

export function buildBoundaryFillOpacityExpression(selectedBoundaryId) {
  const id = normalizeBoundaryId(selectedBoundaryId);
  const base = ["to-number", ["coalesce", ["get", "fillOpacity"], 0.28]];
  if (!id) return base;
  const isSelected = ["==", ["to-string", ["coalesce", ["get", "boundaryId"], ""]], id];
  return [
    "case",
    isSelected,
    ["min", 0.7, ["+", base, 0.08]],
    ["*", base, 0.26],
  ];
}

export function buildBoundaryLineOpacityExpression(selectedBoundaryId) {
  const id = normalizeBoundaryId(selectedBoundaryId);
  if (!id) return 0.85;
  return [
    "case",
    ["==", ["to-string", ["coalesce", ["get", "boundaryId"], ""]], id],
    0.12,
    0.2,
  ];
}

export function extendLngLatBounds(bounds, geometry) {
  const visit = (coords) => {
    if (!Array.isArray(coords)) return;
    if (typeof coords[0] === "number" && typeof coords[1] === "number") {
      bounds.extend(coords);
      return;
    }
    coords.forEach(visit);
  };
  visit(geometry?.coordinates);
  return bounds;
}
